export default "__VITE_ASSET__B77iFJKH__"